import React from 'react';
import SpriteSVG from '@components/1-atoms/SpriteSVG';
import { Card, CheckBadge, Description, Title } from './IntentCard.styled';

export interface IntentCardProps {
  /** Stable id for analytics + persistence. */
  id: string;
  title: string;
  description: string;
  selected: boolean;
  onToggle: (id: string) => void;
  dataTestId?: string;
}

/**
 * Selectable card for the onboarding "What do you want to do?" step.
 *
 * Large rectangular card in a 2-col grid. A small filled checkmark badge
 * appears in the top-right corner when selected. Behaves as a checkbox
 * (multi-select) — keyboard activation comes for free from rendering as a
 * `<button>`.
 */
const IntentCard: React.FC<IntentCardProps> = ({
  id,
  title,
  description,
  selected,
  onToggle,
  dataTestId,
}) => {
  const cardTestId = dataTestId ?? `intent-card-${id}`;
  return (
    <Card
      type="button"
      role="checkbox"
      aria-checked={selected}
      data-testid={cardTestId}
      $selected={selected}
      onClick={() => onToggle(id)}
    >
      {selected && (
        <CheckBadge data-testid={`${cardTestId}__check`}>
          <SpriteSVG name="done_0" />
        </CheckBadge>
      )}
      <Title>{title}</Title>
      <Description>{description}</Description>
    </Card>
  );
};

export default IntentCard;
